import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.66666 2.31714H15.6667C16.4122 2.31714 17.0163 2.92116 17.0163 3.66675V15.6667C17.0163 16.4123 16.4122 17.0164 15.6667 17.0164H3.66666C2.92107 17.0164 2.31705 16.4123 2.31705 15.6667V3.66675C2.31705 2.92116 2.92107 2.31714 3.66666 2.31714Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.41718 11.6669L8.91718 8.16687L11.4172 10.6669L14.4172 7.66687",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }